import { useState, useEffect } from "react";
import { api } from "../api/client";
import { Spinner, FormGroup } from "../components/UI";

const SCOPE_LABEL = { mitgliedsantrag: "Mitgliedsanträge → Beschlussvorlage" };

export default function ApiSchluessel() {
  const [keys, setKeys] = useState(null);
  const [bezeichnung, setBezeichnung] = useState("");
  const [neuerKey, setNeuerKey] = useState(null);

  const laden = () => api.getApiKeys().then(setKeys);
  useEffect(() => { laden(); }, []);

  if (!keys) return <Spinner />;

  const anlegen = async () => {
    if (!bezeichnung.trim()) return;
    const r = await api.createApiKey(bezeichnung.trim(), "mitgliedsantrag");
    setNeuerKey(r.key);
    setBezeichnung("");
    laden();
  };

  const widerrufen = async (id) => {
    if (!window.confirm("Diesen API-Schlüssel widerrufen? Die externe Anbindung funktioniert danach nicht mehr.")) return;
    await api.revokeApiKey(id);
    laden();
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="breadcrumb">Verwaltung</div><h2>API-Schlüssel</h2></div>
      </div>
      <div className="content" style={{ maxWidth: 700 }}>
        <div style={{ fontSize: 12.5, color: "var(--ink-soft)", marginBottom: 16 }}>
          Für externe Integrationen wie die Onboarding-Website: sobald dort ein Mitgliedsantrag genehmigt wird, kann sie mit diesem Schlüssel automatisch eine Beschlussvorlage in FoxFlow anlegen.
        </div>

        {neuerKey && (
          <div className="alert alert-success" style={{ wordBreak: "break-all" }}>
            <strong>Schlüssel wurde erstellt - jetzt kopieren, er wird nie wieder angezeigt:</strong>
            <div style={{ fontFamily: "var(--mono)", fontSize: 13, marginTop: 6, padding: 8, background: "#fff", borderRadius: 4 }}>
              {neuerKey}
            </div>
          </div>
        )}

        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-header"><h3>Aktive Schlüssel</h3></div>
          <table className="table">
            <thead><tr><th>Bezeichnung</th><th>Verwendungszweck</th><th>Erstellt</th><th>Zuletzt genutzt</th><th></th></tr></thead>
            <tbody>
              {keys.map(k => (
                <tr key={k.id}>
                  <td>{k.bezeichnung}</td>
                  <td style={{ fontSize: 12 }}>{SCOPE_LABEL[k.scope] || k.scope}</td>
                  <td style={{ fontSize: 12, color: "var(--ink-faint)" }}>{k.created_at?.slice(0, 10)}</td>
                  <td style={{ fontSize: 12, color: "var(--ink-faint)" }}>{k.letzte_nutzung ? k.letzte_nutzung.slice(0, 16).replace("T", " ") : "Noch nie"}</td>
                  <td className="actions">
                    <button className="btn btn-ghost btn-sm" style={{ color: "var(--danger)" }} onClick={() => widerrufen(k.id)}>Widerrufen</button>
                  </td>
                </tr>
              ))}
              {keys.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: "center", color: "var(--ink-faint)", padding: 24 }}>Keine API-Schlüssel vorhanden.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="card">
          <div className="card-header"><h3>Neuen Schlüssel erstellen</h3></div>
          <div className="card-body">
            <FormGroup label="Bezeichnung">
              <input className="form-control" placeholder="z.B. Onboarding-Website" value={bezeichnung} onChange={e => setBezeichnung(e.target.value)} />
            </FormGroup>
            <button className="btn btn-primary" onClick={anlegen}>Schlüssel erstellen (Zweck: Mitgliedsanträge)</button>
          </div>
        </div>
      </div>
    </div>
  );
}
